import { CommonSystemError } from "../error";
export const isNever = (v) => {
    throw new CommonSystemError.AssertionFailure(`unexpected value ${v}`);
};
//# sourceMappingURL=nevert-type-guards.js.map